import { useMemo } from "react";
import { useAccount as _useAccount } from "wagmi";
export const useAccount = () => {
 const { address, isConnected } = _useAccount();
 const shortAccount = useMemo(
  () =>
   address
    ? `${address.substring(0, 7)}...${address.substring(address.length - 5)}`
    : "",
  [address]
 );
 return {
  account: address,
  shortAccount,
  isConnected,
 };
};
